/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CategoryModalEdit from '../Modals/ServicesModalEdit'
import TeamModalEdit from '../Modals/TeamModalEdit'
import FaqVideoEditModal from '../Modals/FaqVideoEditModal'
import { Description } from '@mui/icons-material'

//
export default function DataTableData() {
  const AppService = useAppServices()
  const params = useParams()
  const navigate = useNavigate()
  const [faq, setFaq] = useState([])
  const [faqVideos, setFaqVideos] = useState([])
  const [categries, setCategries] = useState([])
  const [loader, setloader] = useState(true)

  const getFaqs = async () => {
    const { response, error } = await AppService.team_services.get({
      query: ``,
    })
    // console.log(response, 'response')
    if (response) {
      setCategries(response.data.map((item) => ({ ...item, label: item.name, value: item._id })))
      setFaq(response.faq)
      setFaqVideos(response.faq_videos)
      setloader(false)
    } else {
      setCategries([])
      setFaq([])
      setloader(false)
    }
  }
  const onLoad = () => {
    getFaqs()
  }
  const handleCategoryDelete = async (id) => {
    const { response } = await AppService.team_services.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  const handleFaqDelete = async (id) => {
    const { response } = await AppService.team_services.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  useEffect(onLoad, [])
  return {
    loader: loader,
    categries: categries,
    handleRefresh: onLoad,
    CategoryDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'description', accessor: 'description' },
        { Header: 'cost_price', accessor: 'cost_price' },
        { Header: 'resell_price', accessor: 'resell_price' },
        { Header: 'Staff Team', accessor: 'staff_team' },
        { Header: 'Staff Tag', accessor: 'staff_tag' },
        { Header: 'Team', accessor: 'team' },
        { Header: 'category', accessor: 'category' },

        // { Header: 'Team', accessor: 'team' },

        { Header: 'Action', accessor: 'action' },
      ],

      rows: categries?.map((data, index) => ({
        name: data.name,
        description: data.description,
        cost_price: data.cost_price,

        resell_price: data.resell_price,
        staff_team: data.staff_team?.map((item) => item.label).join(', ') || 'N/A',
        staff_tag: data.staff_tag?.map((item) => item.label).join(', ') || 'N/A',
        team: data.team?.map((item) => item.label).join(', ') || 'N/A',
        category: data.category.name,
        action: (
          <div className="d-flex">
            <CategoryModalEdit handleRefresh={onLoad} editData={data} />
            <MDBox>
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleCategoryDelete(data._id)}
              >
                Delete
              </MDButton>
            </MDBox>
          </div>
        ),
      })),
    },
    FaqDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: faq?.map((data, index) => ({
        question: data.question,
        action: (
          <MDBox>
            <TeamModalEdit categries={categries} handleRefresh={onLoad} editData={data} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleFaqDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },

  }
}
